import { AlgoliaIndexes, getAlgoliaIndex } from '@core/algolia';
import useAlgoliaQuery from './useAlgoliaQuery';

/**
 * This logs an algolia request so we can start tracking Search terms before it goes "live"
 *
 * @param cultureCode - The culture code to use for the query
 * @param searchTerm - The search term to use for the query
 * @param algoliaEnvironmentPrefix - The environment prefix to use for the query
 * @returns void
 * @example
 * useAlgoliaFakeQuery('en-TT', 'drill', 'development');
 */
function useAlgoliaFakeQuery(
  cultureCode: string,
  searchTerm: string | null,
  algoliaEnvironmentPrefix: string | null,
): void {
  const algoliaIndex = getAlgoliaIndex(AlgoliaIndexes.products, cultureCode, algoliaEnvironmentPrefix);
  useAlgoliaQuery(algoliaIndex, searchTerm ?? '', {
    hitsPerPage: 0,
    page: 0,
  });
}

export default useAlgoliaFakeQuery;
